module.exports = __webpack_public_path__ + "a59d09e20e46797c0d961fd1b3cbdda9.jpg";